import React, { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack';
import { Box, Button, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import * as chanceApi from '../../../lib/api/chance';


const ProjectInfo = ({ id }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [project, setProject] = useState(null);
    useEffect(() => {
        if (id) {
            loadProject(id);
        }
    }, [id])


    const loadProject = async (id) => {
        try {
            const response = await chanceApi.getChance(id);
            if (response.data.info) {
                setProject(response.data.info)
            }

        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
    }

    if (!project) {
        return null;
    }

    return (
        <Box>
            <TableContainer component={Box}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>고객명</TableCell>
                            <TableCell>사업명</TableCell>
                            <TableCell>프로젝트 번호</TableCell>
                            <TableCell>부서</TableCell>
                            <TableCell>생성자</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow >
                            <TableCell>{project?.partnerInc}</TableCell>
                            <TableCell>{project?.cstNm}</TableCell>
                            <TableCell>{project?.prjNo}</TableCell>
                            <TableCell>{project?.crtDptNm}</TableCell>
                            <TableCell>{project?.crtNm}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default ProjectInfo